<template>
  <div class="app-wrapper" :class="classObj">
    <div v-if="device==='mobile'&&sidebar.opened" class="drawer-bg" @click="handleClickOutside" />
    <div v-else-if="shade" class="drawer-bg" @click="handleClickShade" />
    <sidebar class="sidebar-container" />
    <div class="main-container">
      <div class="view_top">
        <tabs-view @refreshPage="handelRefreshPage" />
        <navbar />
      </div>
      <el-scrollbar wrap-class="layout-scrollbar-wrapper" style="height: calc(100vh - 60px)">
        <app-main ref="appMain" />
      </el-scrollbar>
    </div>
  </div>
</template>
<script>
import { Navbar, Sidebar, AppMain, TabsView } from './components'

import ResizeMixin from './mixin/ResizeHandler'
export default {
  name: 'Layout',
  components: {
    Navbar,
    Sidebar,
    AppMain,
    TabsView
  },
  mixins: [ResizeMixin],
  data() {
    return {

    }
  },
  computed: {
    sidebar() {
      return this.$store.state.app.sidebar
    },
    device() {
      return this.$store.state.app.device
    },
    shade() {
      return this.$store.state.app.shade
    },
    classObj() {
      return {
        hideSidebar: !this.sidebar.opened,
        openSidebar: this.sidebar.opened,
        withoutAnimation: this.sidebar.withoutAnimation,
        mobile: this.device === 'mobile'
      }
    }
  },
  methods: {
    handleClickOutside() {
      this.$store.dispatch('closeSideBar', { withoutAnimation: false })
    },
    handleClickShade() {
      this.$store.dispatch('closeShade', { shade: false })
    },
    /**
     * 刷新当前页面
     */
    handelRefreshPage() {
      this.$refs.appMain.handelReloadPage()
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
@import "src/styles/mixin.scss";
@import "src/styles/variables.scss";

.view_top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  // background-color: $c;
}

.app-wrapper {
  @include clearfix;
  position: relative;
  height: 100%;
  width: 100%;
  &.mobile.openSidebar {
    position: fixed;
    top: 0;
  }
}
.drawer-bg {
  background: #000;
  opacity: 0.3;
  width: 100%;
  top: 0;
  height: 100%;
  position: absolute;
  z-index: 999;
}
</style>

<style>
.layout-scrollbar-wrapper {
  overflow-x: hidden !important;
  padding-bottom: 1px !important;
}
</style>
